/** Dash placeholder for empty table cells. Defined here (outside the component tree) to avoid circular imports. */
export const emptyCellDash = "-";

/** Fallback image shown when a material/finish image fails to load. I.e. "/images/product-image-fallback.svg". */
export const PRODUCT_FALLBACK_IMG_URL = "/images/product-image-fallback.svg";
/** Placeholder image shown when a material/finish has no image. I.e. "/images/product-empty-state.svg". */
export const PRODUCT_EMPTY_STATE_IMG_URL = "/images/product-empty-state.svg";
